let search_text = $("input.js-filter-career");

$("#frm-search-job").submit(function(e){
    e.preventDefault();
    let query_text = $("input.js-filter-career").val();
    //console.log(query_text);
    search_job(query_text);
});

$("input.js-filter-career").on('keydown', function (e) {
    var keycode = (e.keyCode ? e.keyCode : e.which);
    if(keycode == '13'){
        e.preventDefault();
        let query_text = $("input.js-filter-career").val();
        search_job(query_text,"h3.js-job-title"); 
    };
});

function search_job(search_text,element_look_into) {
    console.log(search_text);
    let r = $(element_look_into+":icontains('"+search_text+"')");
    let jobs_visible = [];
    $(r).each(function(index){
        let container = $(this).closest('li.c-jobs__item').attr('id');
        jobs_visible.push("#"+container);
    });
    separator = ', ';
    jobs_visible = jobs_visible.join(separator);
    console.log(jobs_visible);
    $("li.c-jobs__item").hide();
    $(jobs_visible).show();
    
    //console.log(container);
    
    /*
    $("h3.js-job-title").each(function (){
        let title = $(this).find("h3.js-job-title");
        //let lw_title = $( "h3.js-job-title").val().toLowerCase();
        //let query_results = $(lw_title+":contains('')");
        //console.log(query_results);
        let r = $(this).find("h3.js-job-title:icontains('"+title+"')");
        console.log(r);
    });
    */
    
 
}
$(".js-select-filter").on('change',function(e){
    let filter_val = $(this).val();
    search_job(filter_val,"div.c-jobs__hours"); 
});
jQuery.expr[':'].icontains = function(a, i, m) {
    return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};